import React, { useEffect } from 'react';
import Header from '../../layouts/header';
import Footer from '../../layouts/footer';
import YoutubeTestimonials from '../youtubeReviews/YoutubeTestimonials';
import '../../../cssFiles/reviews_testimonials.scss';

const ReviewsTestimonials = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://elfsightcdn.com/platform.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <>
      <Header />

      {/* ── Hero ─────────────────────────────────────────────────── */}
      <div className="cv-hero">
        <div className="cv-hero-bg-circles" aria-hidden="true">
          <span className="cv-circle cv-circle--1" />
          <span className="cv-circle cv-circle--2" />
          <span className="cv-circle cv-circle--3" />
        </div>
        <div className="cv-hero-content">
          <span className="cv-hero-eyebrow">Trusted by Investors Across India</span>
          <h1 className="cv-hero-title">
            Customer <span className="cv-hero-title--accent">Voices</span>
          </h1>
          <p className="cv-hero-subtitle">
            Real experiences. Real returns. Hear directly from thousands of investors who trust Niveza with their financial future.
          </p>

          <div className="cv-stats-row">
            <div className="cv-stat">
              <span className="cv-stat-number">4,00,000+</span>
              <span className="cv-stat-label">Registered Members</span>
            </div>
            <div className="cv-stat-sep" />
            <div className="cv-stat">
              <span className="cv-stat-number">14,000+</span>
              <span className="cv-stat-label">Paid Subscribers</span>
            </div>
            <div className="cv-stat-sep" />
            <div className="cv-stat">
              <span className="cv-stat-number">10+</span>
              <span className="cv-stat-label">Years of Excellence</span>
            </div>
          </div>

          <div className="cv-appeared">
            <span className="cv-appeared-label">As featured in</span>
            <div className="cv-appeared-logos">
              <img src="/images/appeared/Business-world.png" alt="Business World" />
              <img src="/images/appeared/PTI.png" alt="PTI" />
              <img src="/images/appeared/Financial-express.png" alt="Financial Express" />
            </div>
          </div>
        </div>

        <div className="cv-hero-quote" aria-hidden="true">&ldquo;</div>
      </div>

      {/* ── Video Testimonials ───────────────────────────────────── */}
      <section className="cv-section cv-section--white">
        <div className="cv-section-header">
          <div className="cv-section-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="23 7 16 12 23 17 23 7" />
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
            </svg>
          </div>
          <h2 className="cv-section-title">Video Testimonials</h2>
          <p className="cv-section-subtitle">Watch real clients share their Niveza journey</p>
          <div className="cv-section-underline" />
        </div>
        <div className="cv-video-testimonials-wrapper">
          <YoutubeTestimonials />
        </div>
      </section>

      {/* ── Written Reviews ──────────────────────────────────────── */}
      <section className="cv-section cv-section--light">
        <div className="cv-section-header">
          <div className="cv-section-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <h2 className="cv-section-title">Google Reviews</h2>
          <p className="cv-section-subtitle">See what our community says about Niveza</p>
          <div className="cv-section-underline" />
        </div>
        <div className="cv-reviews-widget-wrapper">
          <div
            className="elfsight-app-5b052f46-add9-419c-b5b3-f4d3fcd30b7d"
            data-elfsight-app-lazy
          />
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ReviewsTestimonials;
